import Tooltip from './tooltip';

const selectors = {
  copyClipboard: '[data-copy-clipboard]',
  tooltip: 'data-tooltip',
};

const sections = {};

class CopyClipboard {
  constructor(section) {
    this.container = section.container;
    this.copyButtons = this.container.querySelectorAll(selectors.copyClipboard);

    if (this.copyButtons.length) {
      this.init();
    }
  }

  init() {
    this.copyButtons.forEach((el) => {
      if (el.hasAttribute(selectors.tooltip)) {
        new Tooltip(el);
      }

      el.addEventListener('click', function (e) {
        e.preventDefault();
        const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const copyText = this.getAttribute('href');
        let inputElem = document.createElement('input');
        inputElem.type = 'text';
        this.appendChild(inputElem);
        const newInput = this.querySelector('input');
        newInput.value = copyText;
        newInput.select();
        newInput.setSelectionRange(0, 99999); /* For mobile devices */
        document.execCommand('copy');
        this.removeChild(newInput);

        if (this.hasAttribute(selectors.tooltip) && windowWidth > 749) {
          this.dispatchEvent(new CustomEvent('poppy:init', {bubbles: true}));

          setTimeout(() => {
            document.dispatchEvent(new CustomEvent('poppy:close'));
          }, 2000);
        }
      });
    });
  }
}

const copyClipboard = {
  onLoad() {
    sections[this.id] = new CopyClipboard(this);
  },
};

export default copyClipboard;
